import { Avatar, Divider, Modal, ModalProps, Stack, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { MESSAGE_SIGNIN_ICON_ARRAY } from '@mygpt/app';

import ChatbotImg from '/chatbot.png';

export const ModalSignatureMessagesTips = (props: ModalProps) => {
  const { t } = useTranslation();

  const IdeaList = [
    {
      title: t('widget.setting.chatbot.signature_tip.list.label_1'),
      desc: t('widget.setting.chatbot.signature_tip.list.text_1'),
      answer: t('widget.setting.chatbot.signature_tip.list.answer_1'),
      signature: t('widget.setting.chatbot.signature_tip.list.signature_1'),
      messages: [
        {
          icon: MESSAGE_SIGNIN_ICON_ARRAY[6],
          message: t('widget.setting.chatbot.signature_tip.list.message_1.msg1'),
        },
      ],
    },
    {
      title: t('widget.setting.chatbot.signature_tip.list.label_2'),
      desc: t('widget.setting.chatbot.signature_tip.list.text_2'),
      answer: t('widget.setting.chatbot.signature_tip.list.answer_2'),
      signature: t('widget.setting.chatbot.signature_tip.list.signature_2'),
      messages: [
        {
          icon: MESSAGE_SIGNIN_ICON_ARRAY[1],
          message: t('widget.setting.chatbot.signature_tip.list.message_2.msg1'),
        },
        {
          icon: MESSAGE_SIGNIN_ICON_ARRAY[0],
          message: t('widget.setting.chatbot.signature_tip.list.message_2.msg2'),
        },
      ],
    },
    {
      title: t('widget.setting.chatbot.signature_tip.list.label_3'),
      desc: t('widget.setting.chatbot.signature_tip.list.text_3'),
      answer: t('widget.setting.chatbot.signature_tip.list.answer_3'),
      signature: t('widget.setting.chatbot.signature_tip.list.signature_3'),
      messages: [
        {
          icon: MESSAGE_SIGNIN_ICON_ARRAY[4],
          message: t('widget.setting.chatbot.signature_tip.list.message_3.msg1'),
        },
      ],
    },
    {
      title: t('widget.setting.chatbot.signature_tip.list.label_4'),
      desc: t('widget.setting.chatbot.signature_tip.list.text_4'),
      answer: t('widget.setting.chatbot.signature_tip.list.answer_4'),
      signature: t('widget.setting.chatbot.signature_tip.list.signature_4'),
      messages: [
        {
          icon: MESSAGE_SIGNIN_ICON_ARRAY[5],
          message: t('widget.setting.chatbot.signature_tip.list.message_4.msg1'),
        },
      ],
    },
    {
      title: t('widget.setting.chatbot.signature_tip.list.label_5'),
      desc: t('widget.setting.chatbot.signature_tip.list.text_5'),
      answer: t('widget.setting.chatbot.signature_tip.list.answer_5'),
      signature: t('widget.setting.chatbot.signature_tip.list.signature_5'),
      messages: [
        {
          icon: MESSAGE_SIGNIN_ICON_ARRAY[7],
          message: t('widget.setting.chatbot.signature_tip.list.message_5.msg1'),
        },
      ],
    },
  ];

  return (
    <Modal title={<Title order={3}>{t('widget.setting.chatbot.signature_tip.title')}</Title>} {...props}>
      <section>
        <Text>{t('widget.setting.chatbot.signature_tip.desc')}</Text>
      </section>
      <section className="my-5">
        <Stack gap={'xl'}>
          {IdeaList.map((item, index) => (
            <div key={index} className="flex gap-8">
              <Stack gap={5}>
                <Title order={5}>{item.title}</Title>
                <Text ml={18} size={'sm'}>
                  {item.desc}
                </Text>
              </Stack>
              <div className="w-1/2 flex gap-3 flex-shrink-0">
                <div className="flex-1">
                  <div className="bg-violet-100 rounded-md rounded-ss-noneed p-4">
                    <Text c="gray.9" fz="xs">
                      {item.answer}
                    </Text>
                    <Divider className="my-3" color="violet.2" />
                    <Text c="gray.5" fz="xs">
                      {item.signature}
                    </Text>
                    {item.messages.map((msg, index) => {
                      return (
                        <div key={index} className="flex gap-2 pt-3">
                          <msg.icon />
                          <Text c="gray.5" fz="xs">
                            {msg.message}
                          </Text>
                        </div>
                      );
                    })}
                  </div>
                  <div className="text-right text-gray-500 text-xs mt-2">
                    {t('widget.setting.chatbot.signature_tip.list.delivery')}
                  </div>
                </div>
                <Avatar radius="xl" src={ChatbotImg} className="flex-shrink-0"></Avatar>
              </div>
            </div>
          ))}
        </Stack>
      </section>
    </Modal>
  );
};
